/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { conclusionSelectors } from '../../../../../../app/resource/conclusion/conclusion.selectors';
import { conclusionsPageSelectors } from '../../../../../../app/page/page-storage/conclusions/conclusions.selectors';
import { storeNotAttended } from '../../../../../../app/page/page-storage/sessions/sessions.actions';
import { sessionsPageSelectors } from '../../../../../../app/page/page-storage/sessions/sessions.selectors';
import { IUser } from '../../../../../../app/resource/user/user.types';
import { useSelect } from '../../../../../../utils/selector.utils';
import { IUserRecapsProps } from './types';
import { UserRecap } from './UserRecap';
import { IConclusion } from '../../../../../../app/resource/conclusion/conclusion.types';
import { getIncompleteRecapUserIds } from '../../../../../../utils/conclusion.utils';

export const UserRecaps: FunctionComponent<IUserRecapsProps> = ({ userIds, loggedUserId, sessionId }) => {
  const conclusions = useSelect(conclusionSelectors.selectResourceList);
  const notAttended = useSelect(sessionsPageSelectors.selectNotAttendedIds);
  const showRecapValidationErrors = useSelect(conclusionsPageSelectors.selectShowRecapValidationErrors);
  const dispatch = useDispatch();
  const incompleteRecapUserIds = getIncompleteRecapUserIds(userIds, sessionId, conclusions, notAttended);

  const handleAttendance = useCallback(
    (userId: IUser['id'], action: string) => {
      if (action === 'add') {
        dispatch(storeNotAttended([...notAttended, userId]));
      } else {
        dispatch(storeNotAttended(notAttended.filter((id) => id !== userId)));
      }
    },
    [dispatch, notAttended],
  );

  return (
    <div className="row mb-25 mt-3">
      <div className="col-12">
        <div className="panel vto-text">
          <div className="panel-header no-border">
            <h2 className="bold">
              Meeting Recap{' '}
              <i
                className="f-1 icon-info blueGray ml-1"
                data-tooltip="Recap and feedback from all participant members of the meeting"
              />
            </h2>
            {/* <div className="ml-auto flex aic">
              <a className="btn btn-md green-bg popup_button" title="Export" data-popup="new_topic_popup">
                <i className="icon-plus" /> Add a Topic
              </a>
            </div> */}
          </div>
          <div className="row">
            <div className="col-12">
              <div className="panel-body pt-0">
                <div className="border-radius-1 lightGray-bg px-2 py-1">
                  <div className="row review-issues-container">
                    {userIds.map((userId) => {
                      const conclusion = conclusions.find(
                        (conc: IConclusion) => conc.sessionId === sessionId && conc.userId === userId,
                      );
                      return (
                        <UserRecap
                          key={userId}
                          loggedUserId={loggedUserId}
                          userId={userId}
                          sessionId={sessionId}
                          conclusion={conclusion}
                          notAttended={notAttended}
                          showValidationError={showRecapValidationErrors && incompleteRecapUserIds.includes(userId)}
                          handleAttendance={handleAttendance}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
